import { propertiesSelectorCreator } from 'app-webtech-core/selectors/propertiesSelector';
import { subselect } from './root';

export const propertiesSelector = propertiesSelectorCreator();

export const podTrackerAdsPropertiesSelector = subselect(propertiesSelector);
